class video {
    constructor() {
        // if($('#video').length) {
        //     this.video();
        // }
        this.events();
    }
    events() {
        if($('.video-wrapper').length) {
            $('.video-wrapper').each((val,index)=>{
                var elem = $(index);
                if(elem.find('.auto-video-player').hasClass('isYoutube')) {
                    this.injectYouTubeAPI();
                } else if(elem.find('.auto-video-player').hasClass('isVimeo')) {
                    this.injectVimeoAPI();
                }
            })
        }
        $(window).on('resize', ()=>{
            if($('#video').length) {
                this.video();
            }
        });

    }
    injectYouTubeAPI() {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://www.youtube.com/iframe_api";
        document.body.appendChild(script);
    }
    injectVimeoAPI() {
        this.loadScriptScr('https://player.vimeo.com/api/player.js', 'callback');
    }
    video() {
        var video = document.querySelectorAll('.video-wrapper');
        var i;
        var wrapperWidth = window.outerWidth;
        for (i = 0; i < video.length; i++) {

            var videoWidth = video[i].offsetWidth,
                videoHeight = video[i].offsetHeight; //this is to get around the elastic url bar on mobiles like ios...

            var wrapperHeight = video[i].parentNode.parentNode.offsetHeight;

            var scale = Math.max(
                wrapperWidth / videoWidth,
                wrapperHeight / videoHeight
            );

            var scale = Math.max(wrapperWidth / videoWidth, wrapperHeight / videoHeight);
            video[i].style.transform = "translate(-50%, -50%) " + "scale(" + scale + ")";
        }
    }
    onYouTubeIframeAPIReady() {
        this.video();
        var lazyVideos = [].slice.call(document.querySelectorAll(".video-wrapper"));
        // window.player;
        if ("IntersectionObserver" in window) {
            var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(videoWrap) {
                    var video = videoWrap.target.getElementsByClassName('auto-video-player')[0];
                    if (videoWrap.isIntersecting) {

                        if (video.getAttribute('src') === null) {
                            var videoId = video.getAttribute('data-video');
                            var elementId = video.getAttribute('id');
                            window.player = new YT.Player(elementId, {
                                width: '100%',
                                videoId: videoId,
                                playerVars: {
                                    'origin': location.protocol + "//" + location.host,
                                    'mute': 1,
                                    'controls': 0,
                                    'autohide': 0,
                                    'showinfo': 0,
                                    'vq': 'hd1080',
                                    'playsinline': '1',
                                    /*'autoplay':1,*/
                                    'loop': 1,
                                    'playlist': videoId,
                                    'theme': 'light',
                                    'color': 'white',
                                    'modestbranding': 1,
                                    'rel': 0
                                },
                                events: {
                                    'onReady': function(event) {
                                        event.target.mute();
                                        event.target.playVideo();
                                        var iframe = event.target.getIframe();
                                        // setTimeout(function() {
                                        iframe.style.display = 'block';
                                        iframe.previousSibling.display = "none";
                                        //}, 1500);
                                    },
                                    'onStateChange': function(event) {

                                        var iframe = event.target.getIframe();
                                        var poster = iframe.parentNode
                                            .getElementsByClassName('poster')[0];
                                        if(poster)
                                        {
                                            if (event.data == 3 || event.data == 0 || event.data == -1) {
                                                poster.style.display = "block";
                                            } else {
                                                poster.style.display = "none";
                                            }
                                        }

                                    }
                                }
                            });
                        } else {
                            if (video.contentWindow !== undefined)
                                video.contentWindow.postMessage(
                                    '{"event":"command","func":"playVideo","args":""}', '*');
                            //setTimeout(function() {
                            if(videoWrap.target.getElementsByClassName('poster')[0]!==undefined) {
                                videoWrap.target.getElementsByClassName('poster')[0].style.display = 'none';
                            }
                            video.style.display = "block";
                            //}, 300);
                        }

                    } else {
                        var video = videoWrap.target.getElementsByClassName('auto-video-player')[0];
                        if(videoWrap.target.getElementsByClassName('poster')[0]!==undefined) {
                            videoWrap.target.getElementsByClassName('poster')[0].style.display = 'block';
                        }
                        if (video.contentWindow !== undefined)
                            video.contentWindow.postMessage(
                                '{"event":"command","func":"pauseVideo","args":""}', '*');
                        video.style.display = "none";
                    }
                });
            }, {
                rootMargin: "256px 0px 256px 0px"
            });

            lazyVideos.forEach(function(lazyVideo) {
                lazyVideoObserver.observe(lazyVideo);
            });
        }
    }
    loadScriptScr(path, callback) {
        var self = this;
        var done = false;
        var scr = document.createElement('script');

        scr.onload = handleLoad;
        scr.onreadystatechange = handleReadyStateChange;
        scr.onerror = handleError;
        scr.src = path;
        document.body.appendChild(scr);

        function handleLoad() {
            if (!done) {
                done = true;
                callback(path, "ok");
            }
        }
        function callback() {
            self.handleLazyLoad();
        }

        function handleReadyStateChange() {
            var state;

            if (!done) {
                state = scr.readyState;
                if (state === "complete") {
                    handleLoad();
                }
            }
        }
        function handleError() {
            if (!done) {
                done = true;
                callback(path, "error");
            }
        }
    }



    handleLazyLoad() {
        var iframe = document.querySelectorAll('.auto-video-player');
        iframe.forEach((item)=>{
            this.injectVimeo(item);
        });

    }
    injectVimeo(iframe) {
        this.video();
        var frameID = iframe.getAttribute('id');
        var videoID = iframe.getAttribute('data-video');
        var options = {
            url: "https://player.vimeo.com/video/"+videoID,
            autoplay: true,
            muted: true,
            loop: true,
            background: true,
            playsinline: true,
            width: 640,
            height: 360
        };

        var player = new Vimeo.Player(frameID,options);
        player.on('bufferend', (data)=>{
            var poster = iframe.parentElement.getElementsByClassName('poster')[0];
            if(poster)
            {
                poster.style.display = "none";
            }
            player.on('play', function () {
                console.log('play')
            });

        });

    }

}

export default video;
